// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AAaw","textarea":"styles_textarea__1kZUY"};